const ROLES = {
  CLIENT: 'client',
  ANALYST: 'analyst',
  ADVISOR: 'advisor'
};

export function getRole() {
  return localStorage.getItem('cordis_role');
}

export function getEngagementId() {
  return localStorage.getItem('cordis_engagement_id');
}

export function requireRole(allowedRoles) {
  const role = getRole();
  if (!allowedRoles.includes(role)) {
    // Log unauthorized attempt
    logUnauthorizedAccess(window.location.pathname, role);
    window.location.href = '/login';
    return false;
  }
  return true;
}

export function setSession(role, engagementId, token) {
  localStorage.setItem('cordis_role', role);
  localStorage.setItem('cordis_engagement_id', engagementId);
  localStorage.setItem('cordis_token', token);
}

export function canApprove() {
  return getRole() === 'advisor';
}

export function canSend() {
  return getRole() === 'advisor';
}

export function canEdit() {
  const role = getRole();
  return role === 'analyst' || role === 'advisor';
}

function logUnauthorizedAccess(attemptedRoute, role) {
  fetch('/api/log', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      action: 'unauthorized_access',
      attempted_route: attemptedRoute,
      role: role || 'none',
      timestamp: new Date().toISOString()
    })
  }).catch(() => {});
}

export { ROLES };
